module.exports = __webpack_public_path__ + "static/media/more-vert.47b1418b.svg";